<template>
    <div class="card card-inverse" :class="`card-${bg}`">
        <div class="card-block">
            <div class="h1 text-muted text-xs-right m-b-2 pull-right">
                <slot name="percents"></slot>
                <i class="fa" :class="`fa-${icon}`" v-if="icon"></i>
            </div>
            <div class="h4 m-b-0">{{ value }}</div>
            <small class="text-muted text-uppercase font-weight-bold">{{ label }}</small>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      value: {
        required: true,
        type: [String, Number]
      },
      label: {
        required: true,
        type: String
      },
      icon: {
        required: false,
        default: null
      },
      bg: {
        required: false,
        default: 'info'
      }
    },
    name: 'DashCard'
  }
</script>



// WEBPACK FOOTER //
// DashCard.vue?73989115